<template>
  <div class="ws-downfile" @click="downfile()">
    <slot>
      <el-tag v-if="name">{{ name }}</el-tag>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: undefined,
    },
    url: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  methods: {
    downfile() {
      const a = document.createElement("a");
      a.style.display = "none"; //隐藏,没必要展示出来
      a.href = this.url;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(a.href); // 释放URL 对象
      document.body.removeChild(a); //完成移除
    },
  },
};
</script>
<style scoped>
.ws-downfile {
  width: auto;
  height: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ws-downfile:hover {
  opacity: 0.6;
}
</style>
